import React, {useEffect, useState} from "react";
import {Button, FormLabel, InputGroup} from "react-bootstrap";
import DropdownDevice from "./DropdownDevice";
import {Link} from "react-router-dom";
import {postUser} from "../../lib/api";
import * as Icon from "react-bootstrap-icons";

function AgreeTermsAndPrivacy(props: { step: number, nextFn: any, realvrUser: object}) {
  const {step, nextFn, realvrUser} = props
  const [device, setDevice] = useState('Meta Quest');
  const [error, setError] = useState(null);

  // @ts-ignore
  const {termsAgree, privacyAgree} = realvrUser.user;
  useEffect(() => {
    if (step !== 1) return;
    if (termsAgree && privacyAgree) {
      nextFn();
    }
  }, [nextFn, privacyAgree, step, termsAgree]);

  if (step !== 1) return null;

  function agree() {
    const now = new Date();
    const isoDateTime = now.toISOString();
    setError(null);
    postUser({
      device,
      terms_agree: isoDateTime,
      privacy_agree: isoDateTime
    }).then((response) => {
      if (response.ok) {
        nextFn();
      } else {
        // @ts-ignore
        setError({message: "Something went wrong"});
      }
    });
  }

  const deviceInstructions = device === 'Meta Quest' ?
    <>
      <div className="row">
        <div className="col-3">
          &nbsp;
        </div>
        <div className="col-8 px-0 pb-3">
          Meta Quest owners please make sure you have updated to the latest OS by
          going in to <span className="orange text-nowrap"><Icon.Gear size={18}/> Settings &gt; About</span> and check if there are any software updates available,
          you may need to first reboot your device and then check again
        </div>
      </div>
    </>
    :
    <>
      <div className="row">
        <div className="col-3">
          &nbsp;
        </div>
        <div className="col-8 px-0 pb-3 setup-terms">
          Please email <a href="mailto:pcvr@realvr.ai">pcvr@realvr.ai</a> to get a link to download the app
        </div>
      </div>
    </>;

  const errorMessage =
    error ?
      <div className="row pb-3 error">
        <div className="col-2">
          &nbsp;
        </div>
        <div className="col-8">
          {(error as any)?.message}
        </div>
      </div>
      : null;

  return (
    <InputGroup>
      <section className="container p-4 rounded profile-wizard">
        <div className="row">
          <div className="col-3 text-right">
            <FormLabel>Your VR Device </FormLabel>
          </div>
          <div className="col-8 px-0 pb-3">
            <DropdownDevice device={device} setDevice={setDevice}/>
          </div>
        </div>
        {deviceInstructions}
        {errorMessage}
        <div className="row py-4">
          <div className="col-3">
            &nbsp;
          </div>
          <div className="col-8 px-0 pb-3 setup-terms">
            View&nbsp;
            <Link to="/terms">Terms of Use</Link>
            &nbsp;and&nbsp;
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            &nbsp;
          </div>
          <div className="col-8 px-0 pb-3">
            <Button
              className="btn-50 next"
              onClick={agree}
              variant="primary"
            >
              Agree to Terms of Use and Privacy Policy
            </Button>
          </div>
        </div>
      </section>
    </InputGroup>
  );
}

export default AgreeTermsAndPrivacy;
